import Vue from 'vue'
import {api} from '@/store/resources'
import access from '@/store/space/access'
import accounts from '@/store/space/accounts'
import banks from '@/store/space/banks'
import budgets from '@/store/space/budgets'
import contractors from '@/store/space/contractors'
import expenses from '@/store/space/expenses'
import incomes from '@/store/space/incomes'
import tags from '@/store/space/tags'
import transactions from '@/store/space/transactions'
import transfers from '@/store/space/transfers'
import calendar from "@/store/space/calendar";
import plannedTransactions from "@/store/space/plannedTransactions";
import goals from "@/store/space/goals";
import trash from "@/store/space/trash";
import apiTokens from "@/store/space/apiTokens";

export default {
    namespaced: true,
    state: {
        current_space: {
            data: {},
            dirty: true
        },
        spaces: []
    },
    getters: {
        spaceInfo: (state) => state.current_space.data,
        spaceCurrency: (state) => state.current_space.data.currency,
        spaceTimeEnabled: (state) => state.current_space.data.time_enabled,
        spaceUseContractors: (state) => state.current_space.data.contractors_enabled,
        spaceFirstTransactions: (state) => {
            let startDate = state.current_space.data.start_at || state.current_space.data.created_at;
            return Vue.prototype.$moment().diff(Vue.prototype.$moment.unix(startDate), 'day')
        },
        spacesList: (state) => state.spaces,
        spaceUserRole: (state) => (userId) => {
            let member = state.current_space.data.members.find(member => member.id === userId);
            return member.role || 0;
        },
        currentUserIsWatcher: (state, getters, rootState) => {
            let userId = rootState.cabinet.user.user_info.data.id;
            let member = state.current_space.data.members.find(member => member.user_id === userId);
            return member.role === 0;
        },
        currentUserIsUser: (state, getters, rootState) => {
            let userId = rootState.cabinet.user.user_info.data.id;
            let member = state.current_space.data.members.find(member => member.user_id === userId);
            return member.role === 1;
        },
        currentUserIsAdmin: (state, getters, rootState) => {
            let userId = rootState.cabinet.user.user_info.data.id;
            let member = state.current_space.data.members.find(member => member.user_id === userId);
            return member.role === 2;
        },
        currentUserIsCreator: (state, getters, rootState) => {
            let userId = rootState.cabinet.user.user_info.data.id;
            return state.current_space.data.creator_id === userId;
        }
    },
    actions: {
        createSpace({commit}, data) {
            return api.spaces.save(data);
        },
        archiveSpace({}, id) {
            return api.spaces.delete({id});
        },
        updateSpace({commit, state}, data) {
            return api.spaces.update({id: state.current_space.data.id}, data);
        },
        leaveSpace({state}) {
            let {id} = state.current_space.data;
            return api.space_leave.save({id}, {})
        },
        async fetchSpaceStartAt({commit, state}) {
            try {
                const id = state.current_space.data.id;
                const res = await api.spaces.get({id, fields: 'start_at'});
                if (res.body.success) {
                    commit('setSpaceStartAt', res.body.data.space)
                }
            } catch (err) {
                console.error(err)
            }
        },
        getCurrentSpaceInfo({commit, rootState}, id) {
            commit('setCurrentSpaceInfoDirty')
            api.spaces.get({id}).then((res) => {
                if (res.body.success) {
                    commit('setCurrentSpaceInfo', res.body.data.space);
                } else {
                    throw res;
                }
            });
        },
        async getActiveSpaces({commit}) {
            const res = await api.spaces.get({status: 1})
            commit('setSpacesList', res.body.data.rows);
        },
        exportSpaceTransactions({state}) {
            return api.space_export_file.save({id: state.current_space.data.id}, {responseType: 'blob'})
        },
        importSpace({state}, {service, report}) {
            //{report, service}
            //  'zenmoney',
            //  'easyfinance',
            //  'sqlite'
            let formData = new FormData();
            formData.append('space_id', state.current_space.data.id);
            formData.append('service', service);
            formData.append('report', report[0]);

            return api.space_import.save(formData)
        }
    },
    mutations: {
        setCurrentSpaceInfoDirty(state) {
            state.current_space.dirty = true;
        },
        clearCurrentSpaceInfoDirty(state) {
            state.current_space.dirty = false;
        },
        setCurrentSpaceInfo(state, data) {
            state.current_space.data = data;
            //update info in space list
            state.spaces = state.spaces.map(space => space.id === data.id ? data : space)
            state.current_space.dirty = false;
        },
        setSpaceStartAt(state, {start_at}) {
            state.current_space.data.start_at = start_at;
        },
        setSpaceMembers(state, data) {
            state.current_space_members = data;
        },
        setSpacesList(state, data) {
            state.spaces = data;
        },
        removeSpace(state, id) {
            state.spaces = state.spaces.filter(i => i.id !== id)
        },
    },

    modules: {
        accounts,
        incomes,
        expenses,
        contractors,
        access,
        tags,
        banks,
        transactions,
        transfers,
        budgets,
        goals,
        calendar,
        plannedTransactions,
        trash,
        apiTokens,
    }
}
